export const GAME_MODE = Object.freeze({
  COMPETITION: 'competition',
  PRACTICE: 'practice',
});

export const PRACTICE_EXERCISES = Object.freeze({
  MIN: 5,
  MAX: 50,
  DEFAULT: 10,
});

export function getGameMode(registry) {
  return registry?.get('gameMode') === GAME_MODE.PRACTICE
    ? GAME_MODE.PRACTICE
    : GAME_MODE.COMPETITION;
}

export function setGameMode(registry, mode) {
  const nextMode = mode === GAME_MODE.PRACTICE
    ? GAME_MODE.PRACTICE
    : GAME_MODE.COMPETITION;

  registry.set('gameMode', nextMode);
  return nextMode;
}

export function normalizePracticeExerciseCount(value) {
  const count = Number(value);
  if (!Number.isInteger(count)) return null;
  if (count < PRACTICE_EXERCISES.MIN || count > PRACTICE_EXERCISES.MAX) return null;
  return count;
}

export function getSessionExerciseCount(registry) {
  return normalizePracticeExerciseCount(registry?.get('sessionExerciseCount'))
    ?? PRACTICE_EXERCISES.DEFAULT;
}

export function setSessionExerciseCount(registry, value) {
  const count = normalizePracticeExerciseCount(value);
  if (count === null) return null;
  registry.set('sessionExerciseCount', count);
  return count;
}
